export default "__VITE_ASSET__DXTG50mS__"